import { useState } from 'react'
import { FiAlertCircle } from 'react-icons/fi'

import { Modal } from 'Components/Ui'
import { Button, Select, TextInput } from 'Components/Form'
import { Form, Formik } from 'formik'

export default function ConfirmationModal({
    children,
    data,
    validation,
    onConfirm,
    title = '',
    message = '',
    className = '',
    maxWidth = 'md',
    fromBankAccounts = [],
    toBankAccounts = [],
}) {
    const [confirming, setConfirming] = useState(false)

    const closeModal = () => setConfirming(false)
    const handleOpen = () => setConfirming(true)

    const submit = (values, { setSubmitting }) => {
        setSubmitting(true)
        closeModal()
        onConfirm(values)
        setSubmitting(false)
    }

    return (
        <div>
            <button type="button" className={className} onClick={handleOpen}>
                {children}
            </button>
            <Modal show={confirming} onClose={closeModal} maxWidth={maxWidth}>
                <Formik initialValues={data || {}} validationSchema={validation} onSubmit={submit}>
                    {({ values, touched, errors, isSubmitting, setFieldValue }) => (
                        <Form className="grid gap-3 p-6 text-center">
                            <span className="inline-block mx-auto">
                                <div className="flex items-center justify-center w-20 h-20 transition rounded-full bg-warning/10 text-warning">
                                    <FiAlertCircle size={40} />
                                </div>
                            </span>
                            <h3 className="text-xl font-bold text-black dark:text-white sm:text-2xl">
                                {title || 'Confirmation Alert!'}
                            </h3>
                            <p className="text-sm">{message || 'Are you sure you want to change status?'}</p>
                            <div className="flex flex-col gap-3 text-left">
                                {'from_account_id' in values && (
                                    <Select
                                        id="from_account_id"
                                        name="from_account_id"
                                        label="From Account"
                                        placeholder="From Account"
                                        value={values.from_account_id}
                                        options={fromBankAccounts.map(e => ({
                                            id: e.id,
                                            label: e.name,
                                        }))}
                                        onChange={e => setFieldValue('from_account_id', e.target.value)}
                                        error={touched.from_account_id && errors.from_account_id}
                                    />
                                )}
                                {'to_account_id' in values && (
                                    <Select
                                        id="to_account_id"
                                        name="to_account_id"
                                        label="To Account"
                                        placeholder="To Account"
                                        value={values.to_account_id}
                                        options={toBankAccounts.map(e => ({
                                            id: e.id,
                                            label: e.name,
                                        }))}
                                        onChange={e => setFieldValue('to_account_id', e.target.value)}
                                        error={touched.to_account_id && errors.to_account_id}
                                    />
                                )}
                                {'amount' in values && (
                                    <TextInput
                                        type="number"
                                        id="amount"
                                        name="amount"
                                        label="Amount"
                                        error={touched.amount && errors.amount}
                                    />
                                )}
                                {'description' in values && (
                                    <TextInput
                                        as="textarea"
                                        id="description"
                                        name="description"
                                        label="Description"
                                        error={touched.description && errors.description}
                                    />
                                )}
                                {'products' in values && (
                                    <>
                                        {values.products.map((product, index) => (
                                            <>
                                                <TextInput
                                                    type="number"
                                                    id={`products[${index}].quantity`}
                                                    name={`products[${index}].quantity`}
                                                    label={`${product.name} (Max: ${product.qty})`}
                                                    error={
                                                        touched.products?.[index]?.quantity && errors.products?.[index]?.quantity
                                                    }
                                                />
                                            </>
                                        ))}
                                    </>
                                )}
                            </div>
                            <div className={`grid grid-cols-1 gap-3 pt-5 md:grid-cols-2`}>
                                <Button type="button" className="w-full text-white border-danger bg-danger" onClick={closeModal}>
                                    No
                                </Button>
                                <Button
                                    className="w-full text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                    disabled={isSubmitting}
                                    type="submit"
                                >
                                    Yes
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </div>
    )
}
